/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import React from 'react';
import PropTypes from 'prop-types';
import { Stack } from '@fluentui/react';
import {
  Button,
  Image,
} from '@fluentui/react-components';
import { EmptyState, EmptyStateContent, EmptyStateSize, EmptyStateSurfaceIcon } from '@bingads-webui-fluent-component/empty-state';

import {
  PERFORMANCE_INSIGHTS_ACTION,
} from './constants/consts';
import IllustrationIcon from './media/illustration.jpg';

export const EmptyView = (props) => {
  const {
    classes,
    newI18n,
    onNavigate,
  } = props;
  return (
    <Stack className={classes.emptyContainer} horizontalAlign="center">
      <EmptyState size={EmptyStateSize.largeSurface} className={classes.emptyState}>
        <EmptyStateContent
          title={newI18n.getString(_TL_('You fixed the issues!'))}
          subtext={newI18n.getString(_TL_('We have some recommendations to further improve your campaign performance.'))}
        >
          <EmptyStateSurfaceIcon>
            <Image src={IllustrationIcon} width="192" alt={newI18n.getString(_TL_('empty result icon'))} />
          </EmptyStateSurfaceIcon>
        </EmptyStateContent>
      </EmptyState>
      <Button className={classes.navigateButton} appearance="primary" onClick={() => onNavigate()}>{newI18n.getString(PERFORMANCE_INSIGHTS_ACTION.VIEW_RECOMMENDATIONS)}</Button>
    </Stack>
  );
};

EmptyView.propTypes = {
  classes: PropTypes.shape({}).isRequired,
  newI18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  onNavigate: PropTypes.func.isRequired,
};
